/**
 * pa-variants.js — PokeAlp variant card enhancer
 * v2 (08/10/2026) : prix formatés dans la devise active (Shopify Markets),
 * plus de "CHF" en dur. Le montant en centimes est exposé en data-cents.
 */
(function () {
  'use strict';

  var variants = window.__pa_variants__;
  if (!variants || !variants.length) return;

  function activeCurrency() {
    try { return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CHF'; } catch (e) { return 'CHF'; }
  }

  function fmt(cents) {
    var cur = activeCurrency();
    var n = cents / 100;
    if (cur === 'CHF') return 'CHF\u00a0' + n.toFixed(2);
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: cur }).format(n);
    } catch (e) {
      return n.toFixed(2) + '\u00a0' + cur;
    }
  }

  function getLang() {
    return (document.documentElement.lang || 'fr').substring(0, 2);
  }

  var i18n = {
    'fr': { savings: 'Vous économisez', best: 'Meilleure offre' },
    'en': { savings: 'You save',        best: 'Best deal' },
    'de': { savings: 'Sie sparen',      best: 'Bestes Angebot' }
  };

  function t(key) {
    var lang = getLang();
    return (i18n[lang] || i18n['fr'])[key];
  }

  var byOpt = {};
  variants.forEach(function (v) {
    if (v.option1) byOpt[v.option1] = v;
  });

  function parseQty(val) {
    var m = val.match(/^(\d+)\s*x/i);
    return m ? parseInt(m[1], 10) : 1;
  }

  var bestPerUnit = Infinity;
  var bestOptValue = null;
  Object.keys(byOpt).forEach(function (key) {
    var perUnit = byOpt[key].price / parseQty(key);
    if (perUnit < bestPerUnit) { bestPerUnit = perUnit; bestOptValue = key; }
  });

  var baseUnitPrice = null;
  Object.keys(byOpt).forEach(function (key) {
    if (parseQty(key) === 1) baseUnitPrice = byOpt[key].price;
  });

  function updateSavingsBadge(v) {
    if (!v) return;
    var qty = parseQty(v.option1 || '');
    var savings = 0;

    if (v.compare_at_price && v.compare_at_price > v.price) {
      savings = v.compare_at_price - v.price;
    } else if (baseUnitPrice && qty > 1) {
      var fullPrice = baseUnitPrice * qty;
      if (fullPrice > v.price) savings = fullPrice - v.price;
    }

    // Scoper à la section pour ne pas trouver un badge dans une autre section
    // (bug accueil : document.querySelector trouve le 1er .hdt-price d'une card produit)
    var sectionEl = window.__pa_section_id__ ? document.getElementById(window.__pa_section_id__) : null;
    var scope = sectionEl || document;

    var badge = scope.querySelector('.pa-savings-badge');

    if (savings > 0) {
      var txt = t('savings') + ' ' + fmt(savings);
      if (badge) {
        // Mise à jour en place — préserver l'icône SVG si elle existe
        var svg = badge.querySelector('svg');
        badge.innerHTML = '';
        if (svg) {
          badge.appendChild(svg);
          badge.appendChild(document.createTextNode(' ' + txt));
        } else {
          badge.textContent = '✓ ' + txt;
        }
        badge.removeAttribute('hidden');
        badge.style.display = '';
      } else {
        // Badge introuvable dans la section — le créer au bon endroit
        badge = document.createElement('span');
        badge.className = 'pa-savings-badge';
        badge.textContent = '✓ ' + txt;
        var priceBlock = scope.querySelector('.hdt-product-price, .hdt-price');
        if (priceBlock) priceBlock.insertAdjacentElement('afterend', badge);
      }
    } else {
      if (badge) {
        badge.setAttribute('hidden', '');
        badge.style.display = 'none';
      }
    }
  }

  function enhance() {
    var inputs = document.querySelectorAll('input[is-value][type="radio"]');
    var count = 0;

    inputs.forEach(function (input) {
      var label = input.nextElementSibling;
      if (!label || !label.classList.contains('is-type-block')) return;
      if (label.querySelector('.pa-vp-inner')) return;

      var v = byOpt[input.value];
      if (!v) return;
      count++;

      var srSpan = label.querySelector('.sr-only');
      var qty = parseQty(input.value);
      var savings = 0;
      if (v.compare_at_price && v.compare_at_price > v.price) {
        savings = v.compare_at_price - v.price;
      } else if (baseUnitPrice && qty > 1) {
        var fullPrice = baseUnitPrice * qty;
        if (fullPrice > v.price) savings = fullPrice - v.price;
      }

      var inner = document.createElement('span');
      inner.className = 'pa-vp-inner';

      var title = document.createElement('span');
      title.className = 'pa-vp-title';
      title.textContent = input.value;

      var price = document.createElement('span');
      price.className = 'pa-vp-price';
      price.setAttribute('data-cents', v.price);
      price.textContent = fmt(v.price);

      inner.appendChild(title);
      inner.appendChild(price);

      if (savings > 0) {
        var sav = document.createElement('span');
        sav.className = 'pa-vp-save';
        sav.textContent = '\u2212\u00a0' + fmt(savings);
        inner.appendChild(sav);
      }

      while (label.firstChild) label.removeChild(label.firstChild);
      if (srSpan) label.appendChild(srSpan);
      label.appendChild(inner);

      if (input.value === bestOptValue && Object.keys(byOpt).length > 1) {
        var badge = document.createElement('span');
        badge.className = 'pa-vp-badge';
        badge.textContent = t('best');
        label.appendChild(badge);
      }
    });

    if (count > 0) {
      document.querySelectorAll('.hdt-product-form__values').forEach(function (c) {
        c.classList.add('pa-vp-ready');
      });
    }

    var checked = document.querySelector('input[is-value][type="radio"]:checked');
    if (checked && byOpt[checked.value]) {
      updateSavingsBadge(byOpt[checked.value]);
    }
  }

  function boot() {
    enhance();
    // moveAccordion(); // Désactivé : garder l'accordéon dans la colonne droite

    document.addEventListener('change', function (e) {
      if (e.target && e.target.hasAttribute('is-value')) {
        var v = byOpt[e.target.value];
        if (v) updateSavingsBadge(v);
        setTimeout(enhance, 0);
      }
    });

    if (!window.MutationObserver) return;

    var root = document.querySelector('main') || document.body;
    var debounce;

    var observer = new MutationObserver(function () {
      clearTimeout(debounce);
      debounce = setTimeout(function () {
        var stale = document.querySelector(
          'input[is-value][type="radio"] + .is-type-block:not(:has(.pa-vp-inner))'
        );
        if (stale) enhance();
      }, 0);
    });

    observer.observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

function moveAccordion() {
  var accordion = document.querySelector(
    '.hdt-product-info__list > [class*="hdt-accordion-style"]'
  );
  if (!accordion || accordion.classList.contains('pa-accordion-moved')) return;

  var grid = accordion.closest('[class*="hdt-secion-main-product"]');
  if (!grid) return;

  grid.parentNode.insertBefore(accordion, grid.nextSibling);
  accordion.classList.add('pa-accordion-moved');

  var gap = document.querySelector('.pa-card-gap');
  if (gap) gap.parentNode.removeChild(gap);

  var list = document.querySelector('.hdt-product-info__list');
  if (list) list.style.paddingBottom = '';
}